(function ($) {
  const $showcaseContainers = $(".paragraph--type--showcase");
  
  $(".paragraph--type--showcase .field--name-field-image").on("click", function() {
    if ($("a", this).length > 0){
      window.location.href = $("a", this).attr("href");
    } 
  });

  $showcaseContainers.each((index, showcase) => {
    // Elements
    const $showcase = $(showcase);
    const $showcaseHeader = $showcase.find(".field--name-field-title");
    const $slider = $showcase.find(".field--name-field-showcase-items");
    const $secondItem = $slider.children().eq(1);
    const $regionWrapper = $("<div>").addClass("region");
    const $sliderWrapper = $("<div>").addClass("track-wrapper");
    const $prevButton = $("<div>").addClass("nav-button nav-button--prev").hide();
    const $nextButton = $("<div>").addClass("nav-button nav-button--next");

    // Props
    const scrollStep = $secondItem.width() + Number($secondItem.css("margin-left").replace("px", ""));
    const scrollDuration = 250;

    // Variables
    let windowWidth = window.outerWidth;

    // ---------------
    // DOM injection
    // ---------------
    $showcaseHeader.wrap($regionWrapper);
    $slider.wrap($sliderWrapper);
    $prevButton.insertAfter($slider);
    $nextButton.insertAfter($slider);

    // ---------------
    // Methods
    // ---------------

    const slider = document.querySelector('.field--name-field-showcase-items');
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener("mousedown", (e) => {
      isDown = true;
      slider.classList.add("active");
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });
    slider.addEventListener("mouseleave", () => {
      isDown = false;
      slider.classList.remove("active");
    });
    slider.addEventListener("mouseup", () => {
      isDown = false;
      slider.classList.remove("active");
    });

    function setTrackPadding() {
      $slider.css("padding-left", getGutterWidth());

      // If there's nothing to scroll, hide the nav button
      if ($slider[0].scrollWidth <= $slider[0].clientWidth) {
        $nextButton.css("visibility", "hidden");
      } else {
        $nextButton.css("visibility", "visible");
      }
    }

    function getGutterWidth() {
      return (windowWidth - $showcaseHeader.width()) / 2;
    }

    function moveSlider(dir) {
      $slider.animate(
        {
          scrollLeft: $slider.scrollLeft() + scrollStep * dir,
        },
        scrollDuration
      );
    }

    function setNavButtonVisibility() {
      const scrollLeft = $slider.scrollLeft();
      const maxScroll = $slider[0].scrollWidth - $slider[0].clientWidth;
      const gutterWidth = getGutterWidth();

      if (scrollLeft > gutterWidth) {
        $prevButton.show();
      }
      if (scrollLeft < maxScroll) {
        $nextButton.show();
      }
      if (scrollLeft <= gutterWidth) {
        $prevButton.hide();
      }
      if (scrollLeft >= maxScroll) {
        $nextButton.hide();
      }
    }

    // ---------------
    // Event handlers
    // ---------------

    // Scrolls to the start of the list 
    $prevButton.on("click", () => moveSlider(-99999));
    $nextButton.on("click", () => moveSlider(1));

    $("body").on("resizeEvent", () => {
      windowWidth = Math.round($(window).width());
      setTrackPadding();
    }).trigger('resize');

    $slider.on("scroll", setNavButtonVisibility);

    // Init methods
    setTrackPadding();
  });
})(jQuery);
